import React from "react";
import UsersList from "./UsersList";

const Users: React.FC = () => {
  return <UsersList />;
};

export default Users;
